export default "__VITE_ASSET__bSqCN1$K__"